// import {
//   BASE_URL
// } from '../../..//common/config.js'
// var gImg = require("../../common/img.js")

var req = require("../../common/img.js")
let gImg = req.default
let { BASE_URL } = require("../../..//common/config.js")
module.exports = {
  // header.vue 页面
  header: {
    Trending: '时事追踪',
    index: "首页",
    center: "中心简介",
    dynamics: '智库动态',
    research: "研究方向",
    journal: '环太文刊',
    countryStats: '万国数据',
    naHsien: "惜才纳贤",
    support: "支持我们",
    contact: '热点关注',
    // contact: "联系我们",
    iconTitle: "创意办公 轻奢商业",
  },
  hot: "战略与安全大事记",
  more: "查阅更多作者文章",
  // 底部
  footer: {
    titleone: '中心简介',
    childrenone: ['中心简介', '环太使命', '核心优势', '理事会', '顾问委员会', '学术委员会', '研究团队', '管理章程', '研究方法', '联系我们'],
    titletow: '智库动态',
    childrentow: ['2018', '2019', '2020', '2021', '2022', '2023', '2024', '2024', '2025', '2026'],
    titlethree: '研究方向',
    childrenthree: ['国际时政', '国际话语', '外交政策', '国防安全', '战略定位', '国别研究', '政治风险', '跨国投资', '课题委约'],
    titlefour: '环太文刊',
    childrenfour: ['政经散论', '环太专报', '前行之路', '坦言', '国家概况', '环太文集', '国家概况'],
    titleseven: '万国数据',
    childrenseven: ['欧盟', '申根地区', '欧元区', '东盟', '上合组织', '世贸组织', '经合组织', 'G20', 'APEC'],
    titlefive: '惜才纳贤',
    childrenfive: ['实习生计划', '奖学金计划', '虚位以待'],
    titlesix: '支持我们',
    childresix: ['机构理事', '团体会员', '个人会员', '学生会员', '课题委约'],
    titleeight: '时事追踪',
    childreneight: ['点击进入'],
    titlenine: '热点关注',
    childrennine: ['点击进入']
  },
  //footer.vue 中的的文件
  affairs: {
    title1: ' 第01期【01.01-01.08】',
    title2: ' 第02期【01.09-01.15】',
    title3: ' 第03期【01.16-01.22】',
    title4: ' 第04期【01.23-01.26】',
    title5: ' 第05期【01.27-01.30】',
    title6: ' 第06期【02.01-02.08】',
    title7: ' 第07期【02.09-01.15】',
    title8: ' 第08期【01.01-01.08】',
    title9: ' 第09期【01.01-01.08】',
    title10: ' 第10期【01.01-01.08】',
    title11: ' 第11期【01.01-01.08】',
    title12: ' 第12期【01.01-01.08】',
    title13: ' 第13期【01.01-01.08】',
    title14: ' 第14期【01.01-01.08】',
    title15: ' 第15期【01.01-01.08】',
    title16: ' 第16期【01.01-01.08】',
    title17: ' 第17期【01.01-01.08】',
    title18: ' 第18期【01.01-01.08】',
    title19: ' 第19期【01.01-01.08】',
    title20: ' 第20期【01.01-01.08】',
    title21: ' 第21期【01.01-01.08】',
    title22: ' 第22期【01.01-01.08】',
    title23: ' 第23期【01.01-01.08】',
    title24: ' 第24期【01.01-01.08】',
    title25: ' 第25期【01.01-01.08】',
    title26: ' 第26期【01.01-01.08】',
    title27: ' 第27期【01.01-01.08】',
    title28: ' 第28期【01.01-01.08】',
    title29: ' 第29期【01.01-01.08】',
    title30: ' 第30期【01.01-01.08】',
    title31: ' 第31期【01.01-01.08】',
    title32: ' 第32期【01.01-01.08】',
    title33: ' 第33期【01.01-01.08】',
    title34: ' 第34期【01.01-01.08】',
    title35: ' 第35期【01.01-01.08】',
    title36: ' 第36期【01.01-01.08】',
    title37: ' 第37期【01.01-01.08】',
    title38: ' 第38期【01.01-01.08】',
    title39: ' 第39期【01.01-01.08】',
    title40: ' 第40期【01.01-01.08】',
    title41: ' 第41期【01.01-01.08】',
    title42: ' 第42期【01.01-01.08】',
    title43: ' 第43期【01.01-01.08】',
    title44: ' 第44期【01.01-01.08】',
    title45: ' 第45期【01.01-01.08】',
    title46: ' 第46期【01.01-01.08】',
    title47: ' 第47期【01.01-01.08】',
    title48: ' 第48期【01.01-01.08】',
    title49: ' 第49期【01.01-01.08】',
    title50: ' 第50期【01.01-01.08】',
    news1: '以色列袭击加沙地带多处目标',
    news2: '哈萨克斯坦爆发抗议活动',
    news3: '“伊斯兰国”袭击叙利亚军车',
    news4: '美国总统与乌克兰总统通电话',
    news5: '五个核武国家发表联合声明',
    news6: '美国在亚太地区部署“林肯”号航母',
    news7: '美国领导联军遭到伊朗及盟国部队袭击',
    news8: '塔利班临时政府军和土库曼斯坦边境警卫爆发冲突',
    news9: '也门胡塞武装扣押阿联酋船只',
    news10: '沙特为首多国联军击落5架胡塞武装无人机',
    news11: '西沙群岛以南海域发现美国军舰',
    news12: '欧盟高级代表访问乌克兰',
    news13: '俄将在哈卡斯组建一个防空导弹团',
    news14: '朝鲜向东部海域发射高超音速导弹',
    news15: '韩空军太空监视光电系统投入实战部署',
    news16: '哈萨克斯坦进入紧急状态',
    news17: '日澳签署防务合作协议',
    news18: '挪威关闭北极圈内主要空军基地',
    news19: '法国战机前往印度进行航母测试',
    news20: '日美举行“2+2”会谈',
    newsText1: '以色列军方2日发表声明称，当地时间2022年1月1日（周六）深夜，以军袭击了加沙地带巴勒斯坦伊斯兰抵抗运动（哈马斯）多处军事目标。声明称，1日，两枚火箭弹从加沙地带射向以色列，落在以色列中部地区附近地中海海域。作为回应，以军直升机和坦克袭击了加沙地带隶属于哈马斯的一个火箭弹制造基地和多处军事哨所。这是以色列近期再次袭击加沙地带目标。',
    newsText2: '当地时间2022年1月2日（周日），哈萨克斯坦西部城市爆发大规模抗议，抗议活动迅速升级，向全国蔓延。据媒体报道，导火索是哈萨克斯坦从1月份开始实行液化石油气价格市场化，结果价格翻倍引发民众不满。为应对动乱，哈萨克斯坦政府表示，液化石油气价格将降至50坚戈/升，同时宣布将市场化交易推迟一年。',
    newsText3: '据叙利亚通讯社3日报道，当地时间2022年1月2日（周日）晚间，极端组织“伊斯兰国”在叙东部沙漠地区向一辆军用巴士发射火箭弹，随后使用加农炮进行攻击，造成叙军方人员5死20伤。另据总部位于英国的“叙利亚人权观察组织”消息，此次袭击造成9名叙利亚士兵死亡。2019年以来，“伊斯兰国”在叙沙漠地区发动的袭击已造成叙军方人员等1625人死亡。',
    newsText4: ' 当地时间2022年1月2日（周日），美国总统拜登就俄罗斯陈兵俄乌边境与乌克兰总统泽连斯基通电话，承诺如果俄罗斯“进一步入侵”乌克兰，美国和盟友将采取“果断”行动。报道注意到，美国和西方盟友准备就相关问题举行一系列外交会议。另据法新社基辅消息，泽连斯基在与拜登通话后表示，乌克兰对美国的“坚定支持”表示赞赏。',
    newsText5: '北京时间2022年1月3日（周一），中、法、俄、英、美共同发表《五个核武器国家领导人关于防止核战争与避免军备竞赛的联合声明》并在声明中强调“核战争打不赢也打不得”，核武器应服务于防御目的、慑止侵略和防止战争；重申不将核武器瞄准彼此或其他任何国家；强调维护和遵守双、多边军控协议和承诺的重要性；强调避免军事对抗、防止军备竞赛 ',
    newsText6: '当地时间2022年1月3日（周一）上午，美国海军“亚伯拉罕·林肯”号航母从母港加利福尼亚州圣迭戈基地出发前往亚太地区，投入到新一轮的部署。和以往不同的是，“林肯”号航母搭载了一个隶属于美国海军陆战队的F-35C舰载机中队。一同出发的还有航母打击大队剩余舰艇，包括一艘导弹巡洋舰和四艘导弹驱逐舰。',
    newsText7: '当地时间2022年1月3日（周一），为报复两年前伊朗高级将领卡西姆·苏莱曼尼被刺杀一事，伊朗及盟国准军事部队向中东地区的美国领导联军发起了一连串袭击。此次袭击持续了三天，1月5日（周三），美国领导联军两个驻伊拉克基地和一个驻叙利亚基地分别遭到至少一次火箭弹等武器袭击，但没有人员伤亡和重大损失。美国领导联军向伊方发起过至少一次反击。',
    newsText8: '当地时间2022年1月3日（周一）早上，阿富汗塔利班临时政府军队和土库曼斯坦边境警卫在贾兹詹省哈马布区（Khamab）的边界线爆发了冲突。阿富汗塔利班临时政府军队于当时前往该地区调查一起平民死亡事件（称该平民是被土库曼军人杀死的），引发了武装冲突。目前双方尚未公布冲突造成的伤亡人数，但阿富汗当地官员称，阿富汗塔利班临时政府军队在冲突中没有伤亡。',
    newsText9: '当地时间2022年1月3日（周一），也门胡塞武装在也门荷台达市附近红海海域扣押了一艘悬挂阿联酋国旗的船。胡塞武装发言人叶海亚·萨里阿表示，这艘船为“军用货轮”，“非法驶入了也门领海”。以沙特为首的多国联军表示，胡塞武装“劫持”了一艘悬挂阿联酋国旗的货轮。多国联军指责胡塞武装的行为违反了国际法，并要求其立即释放该货轮，否则“联军将采取一切必要措施，包括使用武力来应对这一违规行为”。',
    newsText10: '当地时间2022年1月3日（周一），沙特为首的多国联军连续击落5架携带爆炸物的无人机。联军司令部发言人指责也门胡塞武装企图使用这些无人机袭击沙特民用目标，但没有透露击落无人机的具体地点。也门战事近期持续焦灼，沙特为首多国联军当天发布的消息显示，24小时内对也门境内的胡塞武装目标实施了35次空袭行动，摧毁20个“军事目标”，并打死230多名武装分子。',
    newsText11: '北京时间2022年1月4日（周二），“哨兵”卫星在西沙群岛以南海域发现美海军一艘“阿利·伯克”级驱逐舰。综合开源信息判断，卫星抓拍到的可能是“查菲”号，接下来是否会闯入中方驻守岛礁12海里，还需密切关注。“查菲”号驱逐舰近日接连在南海海域开展飞行作业、弹药装填训练。除“查菲”号驱逐舰外，美国海军的“塔尔萨”号濒海战斗舰近期也在南海活动。',
    newsText12: '当地时间2022年1月4日（周二），欧盟外交与安全政策高级代表博雷利到访乌克兰。博雷利在乌克兰外长库列巴的陪同下，先访问了乌克兰东部地区及军事接触线，其后在乌克兰首都基辅会晤乌克兰政府官员。5日，博雷利在记者会上公开喊话美国和俄罗斯，称现在已非“雅尔塔协定”时代，不是两个大国划分势力范围的时候了，欧盟需在与俄罗斯的会谈中发挥作用。',
    newsText13: '当地时间2022年1月4日（周二），俄罗斯中央军区新闻处发布消息称，2022年将在哈卡斯共和国组建一个装备“铠甲-S”弹炮合一系统的防空导弹团。根据计划，该团将担负该地区的防空战备值班任务。该防空系统用于打击飞机、直升机、巡航导弹和高精度武器，从而对小型军事设施、行政和工业设施及区域进行空防。它由两门双管防空高射炮和12枚防空导弹组成。',
    newsText14: '当地时间2022年1月5日（周三）早晨，韩国联合参谋本部发布消息称，朝鲜当天向东部海域发射不明飞行器。日本海上保安厅也发布消息称，朝鲜方面发射了可能是弹道导弹的飞行物。朝中社1月6日报道，朝鲜国防科学院1月5日进行了高超音速导弹试射。朝鲜劳动党中央委员会军需工业部和国防科学部门的有关领导干部观摩了试射。',
    newsText15: '当地时间2022年1月5日（周三），韩军首个太空监视战力“太空监视光电系统”实战部署纪念仪式在作战司令部举行。该系统由控制、检测和识别系统组成，将分析首尔半径2000公里、高度700千米以下的低轨卫星和空间物体的轨迹及影像信息，以保护韩军主要资产。空军表示，这是韩军太空监测战力首次投入实战部署，为执行多方面太空作战任务奠定基础。',
    newsText16: '当地时间2022年1月5日（周三）凌晨，由于此前液化石油气价格市场化引发的抗议活动进一步恶化，总统托卡耶夫宣布曼格斯套州和阿拉木图市自当天凌晨1时30分进入紧急状态，至1月19日0时结束。之后又签署总统令，宣布全国进入紧急状态。集体安全条约组织（集安组织）6日说，应托卡耶夫请求，集安组织决定在哈短期部署维和部队。',
    newsText17: '当地时间2022年1月6日（周四），日本首相岸田文雄和澳大利亚总理莫里森举行视频会议，签署了有关日本自卫队和澳大利亚军队联合训练和应对灾害的《互惠准入协定》（RAA）。RAA是部队联合训练时简化携带武器入境和海关手续的协定，使两国间部队派遣变得顺畅，安全合作更方便展开。除了《日美地位协定》，这是日本首次缔结此类协定。',
    newsText18: '当地时间2022年1月6日（周四），挪威关闭北极圈内主要的空军基地——博德空军基地。该基地位于北极圈以北约80公里，挪威海沿岸，战略位置十分重要，飞行较短距离就可保护北部领空免遭从科拉半岛起飞的俄罗斯军机的袭击。关闭该空军基地还标志着F-16战机长达40年作为挪威空军主力战机历史的结束。挪威空军新的F-35A隐身战机群将主要驻扎在奥兰空军基地。',
    newsText19: '当地时间2022年1月6日（周四），法国“阵风M”舰载战斗机前往印度进行陆基起降测试，与美国的F/A-18E/F“超级大黄蜂”战斗机展开正面竞争，竞标印度海军的新型舰载战斗机项目。印度很可能将基于这项测试结果和其他因素，为首艘国产航母“维克兰特”号选择所用的舰载机。报道还总结说，印度所做的这一切都是发生于中国在航母领域快速发展的背景之下。',
    newsText20: '当地时间2022年1月7日（周五），日美以视频方式召开外长、防长“2+2”会谈。除日本外务大臣林芳正、防卫大臣岸信夫、美国国务卿布林肯、国防部长奥斯汀以外，即将赴任的美国驻日本大使伊曼纽尔也出席了本次会议。此次是岸田内阁的首次日美“2+2”会谈。双方就2022到2026年度增加驻日美军驻留经费日方分摊额度（体贴预算）达成共识。',
    newsAuthor: '【时事追踪-环太战略与安全大事记】乃上海环太国际战略研究中心于2022年起推出的信息分享产品，每周一期，旨在帮助广大读者快速回顾过往一周国际间在战略与安全领域发生的重大事件及其事态跟踪，所有信息和资讯均来源于国内和国际主流媒体的公开报道，并由本中心研究与出版部负责收集和整理。',
    edition: '本期编辑',
    assistant: '编辑助理',
    arrangement: '整理上传'
  },
  address: [{
    title: '地址',
    data: '上海市天钥桥路333号腾飞大厦10楼1001室'
  }, {
    title: '邮编',
    data: '200030'
  }, {
    title: '电话',
    data: '8621 6121 8787'
  }, {
    title: '电邮',
    data: 'info@rimpac-shanghai.cn'
  }],
  contact: "联系我们",
  footerText: {
    textone: '隐私政策',
    texttwo: '使用约定 ',
    textthree: '免责声明'
  },
  copyright: {
    listone: '版权所有：',
    listtow: '© 2019-2022 上海环太国际战略研究中心',
    listthree: '本网站由环球华置商务服务（上海）有限公司设计、制作并维护。',
  },
  //research.vue页面
  title: {
    one: '时逢百年不遇之大变局',
    two: '本中心继续坚持以捍卫国家利益为宗旨，本着尊重知识，放眼全球的原则',
    three: '积极从事各项研究工作，为实现善政和营造有利的国际环境助力中华之崛起',
  },
  //index.vue 页面
  PrimaryTitle: {
    one: '热点关注',
    two: '环太文刊',
    three: '智库动态',
    four: '中心简介',
    five: '研究方向',
    six: '研究团队',
    seven: '惜才纳贤',
    eight: '环太使命',
    nine: '管理规章',
    eleven: '倡导建议以和平与发展为宗旨的新时代国际关系与国际秩序',
    twelve: '上海环太国际战略研究中心成立于2000年8月，是在上海市民政局合法注册登记的民办非企业单位（法人），海市社会科学界联合会为业务主管单位。作为在时任海峡两岸关系协会会长汪道涵的关心下最早成立的民间智库之一，本中心致力于围绕中国政治、经济发展和安全利益有关的课题与政策研究，以中国利益为先，以保障我国在全球范围内的经济利益、在国际事务中获取更大的话语权为己任，倡导建立以和平与发展为宗旨的新时期国际关系与秩序。',
    thirteen: '本中心在制定阶段性研究方向和课题过程中，不仅关注国际局势的风云变换，更注重正在逐渐走向国际舞台的中国的国际战略、国际关系、国际形象、国际话语的探索与论证。中心自成立以来，曾先后完成了一系列涉及全球战略、国家安全和两岸关系等重大课题研究，与国内外多个智库合作开展学术交流活动和举办国际学术研讨会，每年向政府提交专题报告和政策建议，编译出版研究报告、论文专著和战略丛刊，受到政府有关领导和学术界的高度重视，部分已被中央领导采纳并付诸实施。2006年和2021年，本中心先后获评“上海市优秀民办社科研究机构”称号。',
    fourteen: '随着我国综合国力的不断增强以及在国际间地位的提升，尤其是伴随大国博弈的日趋激烈，本中心与时俱进，积极主动地参与乃至主持国际学术交流，并开拓研究领域，在原有架构的基础上，增设多个区域研究中心，陆续创建定期刊物和系列讲座，为青年学者和研究专才提供奖学金计划，务求不辱使命，领行业之先，更好更全面地为政府和企业建营献策，并提供具国际水准的专业咨询服务。',
    fifteen: '支持我们',
    sixteen: '时事追踪',
    seventeen: '观点策论',
    eighteen: '环文周刊',
    nineteen: '智库动态',
    twenty: '环太文刊'

  },
  // journal.val  环太文刊页面
  journalList: [
    {
      id: 'strategicAndSecurityWatch',
      img: gImg.journal.one,
      title: '环太战略与安全观察',
      secondaryTitle: '年刊 / 由本中心与出版社合作出版发行',
      secondaryTitleTwo: '',
      content: '自2022年年底起，本中心正式编撰年度学刊类出版物《环太战略与安全观察》，并于2023年上半年正式公开出版，本刊由中心学术委员会组建专职团队撰写，以战略视野和理性思维，聚焦全球安全为题，解析国际关系互动下全球和地区态势及相关问题，已达学术交流和知识共享之目的。',
      contentTwo: '若需订购，请与本中心联系或发邮件至publications@rimpac-shanghai.cn查询。',
      contentThree: ''
    },
    {
      id: 'internationalSecurityAndResearch',
      img: gImg.journal.two,
      title: '国际安全思辨与研究',
      secondaryTitle: '文集 / 由本中心汇编',
      secondaryTitleTwo: '季刊 / 季度过后30天内面世',
      content: '本中心汇编推出的季刊《国际安全思辨与研究》，旨在与本中心会员和广大读者分享由中心研究员和特约研究员所撰写的反应其独立思考和见解的专题评论文章，确保所刊文章均系原创首发或授权译稿，且已征得原文作者的同意和授权、原文著作权归作者所有，文稿的作者对所撰文稿的原创性做出保证。',
      contentTwo: '',
      contentThree: '点击《国际安全思辨与研究》可下载过往推出的文集。若需订购，请与本中心联系或发邮件至publications@rimpac-shanghai.cn。'
    },
    {
      id: 'anterior',
      img: gImg.journal.three,
      title: '前行之路',
      secondaryTitle: '会务集锦 / 由本中心汇编',
      secondaryTitleTwo: '不定期推出',
      content: '本中心推出的《前行之路》图文集锦系列，乃专题汇总报道每次由本中心主持和主导的专题论坛、大型研讨会或学术活动及会务实况，图文并茂地如实展示各类会务及活动的主题和精彩片段，同时也对与会嘉宾在会上和席间所发表的观点与独特见解进行汇总性报道。',
      contentTwo: '',
      contentThree: '点击《前行之路》可下载最新一期的会务集锦。若需获取更多《前行之路》图文集锦，欢迎来电与本中心联系或发邮件至publications@rimpac-shanghai.cn。'
    },
    {
      id: 'specialReports',
      img: gImg.journal.four,
      title: '环太专报',
      secondaryTitle: '内部资料 / 由本中心汇编',
      secondaryTitleTwo: '不定期推出',
      content: '已推出100多期的《环太专报》是由本中心不定期编辑的内刊，供有关领导和政府部门在决策时作参考。每期专报均主题鲜明、简明扼要，针对特殊事件或议题进行专题通报或论述。作为内刊，本中心对《环太专报》收件人的信息严格保密，并直接快递至收件人本人。',
      contentTwo: '',
      contentThree: ''
    },
    {
      id: 'sayFrankly',
      img: gImg.journal.five,
      title: '坦言',
      secondaryTitle: '内部资料 / 由本中心与上海东方研究院联合汇编',
      secondaryTitleTwo: '不定期推出',
      content: '《坦言》是一份不定期的内刊，由本中心与“上海东方研究院”共同合作发起，于2019年1月起首度推出，旨在为从事国际关系和外交政策研究的专家学者和独立研究人员提供一个发表研究成果、学术观点的交流平台。我们崇尚学术自由和学术争鸣，每期内容编辑整理后，供政府相关部门和受邀读者参阅。',
      contentTwo: '',
      contentThree: ''
    },
    {
      id: 'collectedWorks',
      img: gImg.journal.six,
      title: '环太文集',
      secondaryTitle: '文集 / 由本中心与出版社合作出版发行',
      secondaryTitleTwo: '不定期推出',
      content: '不定期地推出《环太文集》系列，选题由中心执委会和学术委员会共同决策，每本《环太文集》将围绕一个特定主题选编自本中心研究员和特约研究员所撰写的时评文章和论文，或是专门为某位中心研究员或特约研究员（包括年轻学者）独身定制的文集，已展现其在特定研究领域的多年成果积累。',
      contentTwo: '',
      contentThree: '若需订购，请与本中心联系或发邮件至publications@rimpac-shanghai.cn查询。'
    },
    {
      id: 'countryProfile',
      img: gImg.journal.seven,
      title: '国家概况',
      secondaryTitle: '专题系列 / 由本中心与环球华置机构联合编译',
      secondaryTitleTwo: '专题系列 / 不定期推出',
      content: '由本中心与跨国投资咨询机构“环球华置”合作编辑和定期更新的中英文双语版的《国家概况》系列出版物，覆盖全球100多个国家，从历史、地理、气候、人口、经济、教育、文化及公共交通等方面，对每个国家的国情及营商环境进行细致和独到的分析与介绍，图文并茂，且每本《国家概况》均获所涉国家驻华使节背书。',
      contentTwo: '',
      contentThree: '点击《国家概况》可在环球华置商务服务（上海）有限公司网站上预览并在线下载少量免费样本。若需订购此系列出版物，请与本中心联系或发邮件至publications@rimpac-shanghai.cn查询。'
    },
  ],
  //naHsien.vue页面
  naHsientitle: {
    one: '上海环太国际战略研究中心重视对青年才俊的发掘和培养，',
    two: '围绕本中心涉足的相关研究领域，愿为本科毕业生提供锻炼机会',
    three: '和职业发展平台，为智库建设广纳贤才。'
  },
  tabList: [{
    img: gImg.CherishTalentsAndAcceptTalents.one,
    title: '实习生计划',
    type: 0,
    id: 'council',
    text: '本中心为本科生和研究生提供实习机会，理想的应聘者需安排出不短于3个月的实习期和每周40小时的工作时间，理想的专业背景包括国际政治、国际关系、国防外交、社会公共事务管理、法学、政治、历史，或英语语言及文学。实习内容包括时政和专题研究、国别研究、策划与组织专题论坛、撰写新闻稿。优秀的实习生可能会在实习期间或之后被本中心正式聘用。',
  }, {
    img: gImg.CherishTalentsAndAcceptTalents.two,
    title: '奖学金计划',
    type: 0,
    id: 'adviser',
    text: '本中心为有志于在国际政治、国际关系、国防外交等领域继续深造的本科毕业生提供奖学金。年度奖学金名额共五人，本中心于每年第二季度公布当年奖学金总额以及签约接受本中心委培研究生的教育机构。奖学金获得者在研读期间申请参与相关课题研究的工作。作为本中心的委培研究生，本中心有权要求其在毕业后为本中心供职和工作不少于两年时间，具体事项参照《奖学金发放约定书》内容。'
  }, {
    img: gImg.CherishTalentsAndAcceptTalents.three,
    title: '助理研究员',
    type: 0,
    id: 'learning',
    text: '助理研究员负责查找、查验本中心故据库中需要定期更新的全球一百多个国家的各类数据、图库和信息。该岗位其他职责包括：按规定的格式与标准参与本中心相关课题研究以及研究报告和《国家概况》系列出版刊物的编写；参与此等工作的助理研究员的姓名将会被列人该等报告和出版刊物的研究或创作人员名单中。理想应聘者的专业背景以国际政治、国际关系、历史、经济学、哲学、法学, 或英语语言及文学为佳。',
  }, {
    img: gImg.CherishTalentsAndAcceptTalents.four,
    title: '投资分析师',
    type: 0,
    id: 'foreign',
    text: '投资分析师的主要职责是负责通过市场或行业研究为各类跨国投资项目的可行性研究提供支持，具体工作内容包括：参与项目背景资料的搜集、查证，分析行业现状及前景，了解市场准人及政策法规，审核项目或企业财务数据等相关信息，将有机会与中外资深投资专家共事，深人了解项目投资及融资结构所涉及的全部事项。理想应聘者的专业背景以经济学、法学、财会或银行与金融为佳。'
  }, {
    img: gImg.CherishTalentsAndAcceptTalents.five,
    title: '政治风险评估师',
    type: 0,
    id: 'team',
    text: '政治风险评估师负责参与有关企业跨境投资过程中的政治风险评估的专业研究工作，研究范围包括：相关国家的历史、文化、政治与经济现状及国家特色；政治生态与党派内情、选举制度、立法与司法程序、廉政举措等；外交政策以及所属国际组织对其的约束等。理想应聘者须对政治风险研究有浓厚兴趣，专业背景以政治学、国际关系学或历史学为佳。',
  }, {
    type: 1,
    id: 'personal',
    text: '申请人需将个人简历、本科毕业成绩单、或申报研读和深造的专业方向等材料，邮寄至中国上海市天钥桥路333号腾飞大厦10楼1001室，台启：环太国际战略研究中心秘书处；或发电邮至：career@rimpac-shanghai.cn。来函需注明申请职位或参与计划的主题，本中心秘书处经初审通过后，会安排时间约见申请人，并定期将申请人情况汇总，报本中心学术委员会作最终审核。一旦评审通过，本中心将向成功获选的申请人发放通知，与其签署聘用协议或相关约定书。中国籍申请人优先。'
  }],

  // support.vue  支持我们

  supportList: [
    {
      id: 'InstitutionGoverningUnit',
      title: '机构理事单位',
      info: [
        {
          type: 0,
          secondaryTitle: '机构理事招募准则',
          content: '为更好地推动本中心的有序发展，更好地服务国家发展的需要并实现本中心既定的宗旨和使命，本中心决定面向社会，在中国的金融、投资、管理、法律、财会、贸易、制造、咨询等各个行业内选择有意向或已经在全球范围内拓展其业务的机构，且该等机构亦认同本中心的宗旨和使命的，欢迎该等机构在加入成为本中心“团体会员”的基础上，以向本中心出资（包括课题委约、会议和活动冠名等）和直接捐赠等方式成为本中心的“机构理事单位”。',
          contentTwo: '申请成为本中心“机构理事单位”的实体不限其所有制性质，但必须是在中国境内合法注册并有效续存的实体性企业或机构，有良好的经营状况、企业形象以及社会责任感，并热心公益事业。“机构理事单位”为本中心提供资金捐赠并缴纳年费后同时成为本中心的“团体会员”，除享受“机构理事单位”和“团体会员”的权益以及本《机构理事单位招募指引》中列明的其他权益外，不参与也不得干涉本中心的日常运营和管理等任何日常事务，以保证中心运作及其研究工作之独立性。',
          contentThree: '',
        },
        {
          type: 0,
          secondaryTitle: '机构理事单位的权益和义务',
          content: `有意成为本中心“机构理事单位”的企业在填写《机构理事单位申请表》、阅读和了解本相关指引的全部内容后，与本中心的“执行管委会”签约正式成为本中心“机构理事单位”。所有“机构理事单位”有义务为本中心的健康发展献计献策，有权参与审阅本中心年度报告和计划、年度财务报告，并每年向本中心提供不少于人民币叁拾万元（RMB300,000）的现金捐赠（不设上限）。所有“机构理事单位”一经签约，其企业名称和标识将在本中心官网及相关宣传资料上公布。年度捐赠现金超过人民币壹佰万元（RMB1,000,000）的“机构理事单位”或个人，可获提名一人出任本中心副秘书长（名誉），年度捐赠现金超过人民币贰佰万元（RMB2,000,000）的“机构理事单位”或个人，可获提名一人出任本中心副理事长（名誉）。所有向本中心提供现金捐赠的个人，须就所捐赠现金为其个人财产作出书面声明。本中心为收到的每笔捐赠金额向捐赠单位和个人提供捐赠证明。`,
          contentTwo: '所有“机构理事单位”将提前收到本中心主持举办的各类主题学术论坛和公开会务活动的通知和详情，有权派代表（上限五人）免费参与和出席该等会务活动。同时，“机构理事单位”有权向本中心“执行管委会”建议召开专题研讨会的主题和议题；有权以出资冠名的方式赞助本中心主持召开“圆桌会议”和“专题论坛”等定期或不定期活动；有权以“课题委约”的方式要求本中小从事定向和专题研究并自行与“执行管委会”商定委约项目的费用及支付方式。',
          contentThree: '所有“机构理事单位”在与“执行管委会”签约时须另行向本中心交纳人民币叁万元整（RMB30,000）的定额年费，成为“环太团体会员”并享受相应待遇，包括：免费获取本中心所有出版文刊的电子版和印刷版（限一式五份）；有权派代表（上限五人）免费参与和出席本中心主持举办的各类主题学术论坛和公开会务活动；有权向本中心提交专题评论文稿，一经采纳，本中心将向撰稿人支付相应稿酬并将文稿在本中心官网和/或出版文刊上发布。',
        },
        {
          type: 0,
          secondaryTitle: '资金来源与财务管理',
          content: '主要资金来源：本中心作为研究机构和民间智库，并非以盈利为目的，资金来源面向社会筹集并通过自身运营获取合理、合法的收入，以支撑和维系中心的日常运营所需。本中心的收入来源主要分为：接受机构理事单位的捐赠资助、团体会员年费、个人会员年费、学生会员年费、受托研究经费以及咨询服务收入。',
          contentTwo: '财务管理制度：本中心严格按照所在地的财税政策和相关法律法规如实记录中心日常运营所发生的所有收支，以严格的内部财务管理制度和规范自我约束、合规守法，向社会和税务部门公开本中的所有资金和收入来源，并接受主管部门的监督。',
          contentThree: '',
        },
        {
          type: 0,
          secondaryTitle: '下载指引文档',
          content: `有兴趣进一步了解如何成为本中心机构理事单位的企业或个人，可点击下载<a class='red textDecoration' href='` + BASE_URL + `/uploads/zhaomu.pdf' download target='_blank'>《机构理事单位招募指引》</a>或直接致电联系本中心秘书处，或发邮件至info@rimpac-shanghai.cn查询。`,
          contentTwo: '',
          contentThree: '',
        },
      ]
    },
    {
      id: 'GroupMembers',
      title: '团体会员',
      info: [
        {
          type: 1,
          content: `只需缴纳3万元年费，您的企业便可积极参与智库建设和本中心的各类活动，拥有冠名定制活动和委约项目特权，并享受多项超值服务。点击下载<a class='red textDecoration' href='` + BASE_URL + `/uploads/tuantihuiyuan.pdf' download target='_blank'>《会员申请表》</a>。`,
        },
        {
          type: 2,
          secondaryTitle: '申请资格：',
          content: '在中国合法登记注册并有效续存的工商企业（所有制性质和行业不限），均可申请成为“环太团体会员”。',
          contentTwo: '',
          contentThree: '',
        },
        {
          type: 2,
          secondaryTitle: '申请程序：',
          content: '在申请表内如实填写所有必填内容后，提供有效工商登记证复印件，将申请表快递至本中心秘书处。',
          contentTwo: '',
          contentThree: '',
        },
        {
          type: 2,
          secondaryTitle: '批准付费：',
          content: '本中心在收到申请资料并核实无误后，秘书处将与您取得联系并在收到您支付会费后，即可成为“环大团体会员”。',
          contentTwo: '',
          contentThree: '',
        },
        {
          type: 0,
          secondaryTitle: '享受待遇：',
          content: `
          <div>01.受邀并免费参加本中心主持举办的各类讲座、发布会、年度会员大会，每次限派遣代表5名；</div>
          <div>02.受邀并免费参加本中心主持或联合主持的常规专题研讨会，每次限派遣代表5名；</div>
          <div>03.免费获取本中心编撰的专题研究报告的电子版；</div>
          <div>04.免费获取本中心官网上展示的所有最新和过往出版文刊的电子版；</div>
          <div>05.可就所关心的时政和专业疑惑随时向本中心提问求答，本中心专家将酌情回复；</div>
          <div>06.可预约派遣代表造访本中心图书资料中心，免费查阅书刊资料、每次限2人，本中心不提供书看资料外借服；</div>
          <div>07.可优先委托本中心提供服务，从事专题性委约课题研究，享受“团体会员”30%的付费折扣优惠；</div>
          <div>08.可以出资形式与本中心协商创办公益性资讯节目、创建研究课题、参与主题性会议等，并获优先冠名权；</div>
          <div>09.有意在本中心研究领域派员继续求学深造，可申请参与“奖学金计划”并获优先考虑；</div>
          <div>10.经预约面试并获准后，可以企业名义或委派代表为中心撰文，文稿一经采纳，将获得稿酬；</div>
          <div>11.定期收阅本中心会员内刊，了解本中心关注的时政焦点以及最新研究项目、活动信息等咨询；</div>
          <div>12.获颁发“环太企业会员”荣誉证书；</div>
          <div>13.获颁发“上海环太国际战略研究中心”徽标十枚，供选派代表出席和参加本中心活动时需佩戴及便于身份识别。</div>
          `,
          contentTwo: '',
          contentThree: '',
        },
      ]
    },
    {
      id: 'IndividualMembers',
      title: '个人会员',
      info: [
        {
          type: 1,
          content: `每月仅需150元，您便可频繁参与本中心的各类活动，获取最新资讯，从此紧贴时政、开阔视野，与国内外专家学者近距离交流，与超前思维的民间智库互动。点击下载<a class='red textDecoration' href='` + BASE_URL + `/uploads/gerenhuiyuan.pdf' download target='_blank'>《会员申请表》</a>。`,
        },
        {
          type: 2,
          secondaryTitle: '申请资格：',
          content: '我们欢迎品行端正、关心国家命运和国际风云变幻的成年人和独立研究员（男女不限），成为“环太个人会员”。',
          contentTwo: '',
          contentThree: '',
        },
        {
          type: 2,
          secondaryTitle: '申请程序：',
          content: '在申请表内如实填写所有必填内容并提供有效身份证复印件后，将申请表快递至本中心秘书处。',
          contentTwo: '',
          contentThree: '',
        },
        {
          type: 2,
          secondaryTitle: '批准付费：',
          content: '本中心在收到申请资料并核实无误后，秘书处将与您联系，您在支付会费后，即可成为“环太个人会员”。',
          contentTwo: '',
          contentThree: '',
        },
        {
          type: 0,
          secondaryTitle: '享受待遇：',
          content: `
          <div>01.受邀并免费参加本中心主持举办的各类讲座、发布会、年度会员大会；</div>
          <div>02.受邀并免费参加本中心主持或联合主持的常规专题研讨会；</div>
          <div>03.免费获取本中心编撰的专题研究报告的电子版；</div>
          <div>04.免费获取本中心官网上展示的所有最新和过往出版文刊的电子版；</div>
          <div>05.可就所关心的时政和专业疑惑随时向本中心提问求答，本中心专家将酌情回复；</div>
          <div>06.可预约造访本中心图书资料中心，免费查阅书刊资料，但本中心不提供书看资料外借服务；</div>
          <div>07.经预约面试并获准后，可为中心撰文，文稿一经采纳，将获得稿酬，受邀参与课题研究者，可得服务费；</div>
          <div>08.定期收阅本中心会员内刊，了解本中心关注的时政焦点以及最新研究项目、活动信息等咨询；</div>
          <div>09.若有意在本中心研究领域继续求学深造，可申请参与“奖学金计划”并获优先考虑；</div>
          <div>10.获颁发“上海环太国际战略研究中心”微标一枚，供出席和参加本中心活动时需佩戴及便于身份识别。</div>
          `,
          contentTwo: '',
          contentThree: '',
        },
      ]
    },
    {
      id: 'StudentMembers',
      title: '学生会员',
      info: [
        {
          type: 2,
          content: `每月仅需50元，您可自豪地成为“环太学生会员”便可从此紧贴时政、开阔视野，与国内外专家学者近距离交流，与超前思维的民间智库互动。点击下载<a class='red textDecoration' href='/uploads/xueshenghuiyuan.pdf' download target='_blank'>《会员申请表》</a>。`,
        },
        {
          type: 2,
          secondaryTitle: '申请资格：',
          content: '您只需提供在校就读的证明文件（专业不限，本科、硕士、博士不限），即可提交申请，成为“环太学生会员”。',
          contentTwo: '',
          contentThree: '',
        },
        {
          type: 2,
          secondaryTitle: '申请程序：',
          content: '在申请表内如实填写所有必填内容并提供有效学生证或校方出具的在读证明副本，快递至本中心秘书处。',
          contentTwo: '',
          contentThree: '',
        },
        {
          type: 2,
          secondaryTitle: '批准付费：',
          content: '本中心在收到申请资料并核实无误后，秘书处将与您联系，您在支付会费后，即可成为“环太学生会员”。',
          contentTwo: '',
          contentThree: '',
        },
        {
          type: 0,
          secondaryTitle: '享受待遇：',
          content: `
          <div>01.受邀并免费参加本中心主持举办的各类讲座、发布会、年度会员大会；</div>
          <div>02.受邀并免费参加本中心主持或联合主持的常规专题研讨会；</div>
          <div>03.免费获取本中心编撰的专题研究报告的电子版；</div>
          <div>04.免费获取本中心官网上展示的所有最新和过往出版文刊的电子版；</div>
          <div>05.可就所关心的时政和专业疑惑随时向本中心提问求答，本中心专家将酌情回复；</div>
          <div>06.定期收阅本中心会员内刊，了解本中心关注的时政焦点以及最新研究项目、活动信息等咨询；</div>
          <div>07.本中心在审核“实习生计划”和“奖学金计划”申请时，“环太学生会员”将获得优先考虑；</div>
          <div>08.获颁发“上海环太国际战略研究中心”微标一枚，供出席和参加本中心活动时需佩戴及便于身份识别。</div>
          `,
          contentTwo: '',
          contentThree: '',
        },
      ]
    },
    {
      id: 'ProjectCommissionAndProjectCooperation',
      title: '课题委约及项目合作',
      info: [
        {
          type: 1,
          content: '本中心接受各级政府部门和企事业单位的委约，从事相关的专题项目研究（包括宏观及国别性国际关系与安全事务研究、地缘战略与趋势研究、国别性外交政策分析、国别性综合国情研究、国别产业发展研究及市场调研、国别性社会及人文事务研究、区域安全事务研究、国别性或区域性舆情及民意调查、等等）。同时，本中心也欢迎国内外各院校和学术机构与我们展开相关之项目合作。若需探讨具体课题委约或项目合作事宜，可直接致电本中心秘书处或发邮件至info@rimpac-shanghai.cn与我们接洽。',
        },
      ]
    }
  ],
  // research.vue 页面
  research: [{
    title: '国际时政',
    info: {
      picture: gImg.ResearchDirection.one,
      textone: `当今世界，地缘政治动荡不断，发展中国家的崛起面临困难和阻力，各国在政治经济领域的相互竞争日趋激烈，矛盾和冲突在逐步升级。我们认为，造成当今世界乱象之根源，既是由于二战以来美国强权规制下的和平体系已经油枯灯灭，也因世界新秩序的建设仍然青黄不接。作为独立的研究机构，我们的使命是在求实的基础上对研究对象及课题进行客观的分析和研判，以科学精神和专业态度对待国际时政的研究，在坚持捍卫中国利益的前提下，深入剖析国际局势的现状及其变化的根源，多维度地分析和揭示事件发生的背后成因，开放性地的解读国际间各家的观点和立场，进而全面了解和掌握事件的真相。 `,
      texttwo: '在乱象丛生之当下，只有时刻保持清醒和冷静，顺着历史的脉络，拨开迷雾，方能看清事物的本质，这也是理性解读国际风云变幻之要诀。我们对国际时事政治的研究，不仅关注世界各地的重大政经动态，更侧重于用全球视野深入观察和研究各主要政治和经济群体间以及国与国之间的互动、博弈乃至争斗态势，进而客观地分析中国在发展道路上所遭遇的不断变化的外部环境，认清国际局势的变化对中国可能产生的影响，研判在国际政治的发展趋势和各类突发事件中我国在国家安全、经济发展、权益保护和利益捍卫等领域所坚持的立场和态度，向国家战略规划和行政决策部门提供相应的专题报告和预警性建议。'
    }
  }, {
    title: '国际话语',
    info: {
      picture: gImg.ResearchDirection.two,
      textone: `在西方话语体系为主导的国际大环境下，一切为中国崛起正言的努力无时无刻不受到来自各方的微词乃至打压。西方霸权横行至今，已经形成了一套从意识形态、人文哲学、文化宗教，到社会治理各个层面的完整的话语体系。面对中国的崛起，守成大国岂会坐以待毙地被我超越。《天演论》中所指的“适者生存”的物种和人类发展的规律，恰好也印证了国际社会领导权和话语权在演变过程中的相互争夺的现实存在。我们认为，闭门造车、自圆其说地试图去创造话语体系，根本达不到预期之功效；研究国际话语体系既要了解现有体系的历史成因，也要认清所处的时代现状，以及未来国际社会的发展趋势。`,
      texttwo: `中国正在力图成为区域话语秩序的构建者和全球话语新秩序的主导者。这是时代的召唤，也是历史对中华民族的考验。应该看到，由于语言、文化、历史和政治体制的不同，我们所习惯的传统的中国式政治术语以及表述方法通常很难在国际间得到正确有效的传递，我们的善意时常会被曲解或误解，我们的宽容和克制也经常被误认为是软弱或无奈。一厢情愿地指望和要求他人的理解是不切实际，而敌对式的强行冲撞既有失大国风范，也得不偿失。认清这一现实，是我们研究国际话语体系并探寻在国际间争夺和建立话语权有效途径的根本性前提，也是我们对相关理论学说和战略实施展开专题研究的基础和方向。`
    }
  }, {
    title: '外交政策',
    info: {
      picture: gImg.ResearchDirection.three,
      textone: `维护世界和平、促进共同发展是中国对外政策的宗旨。然而，霸权主义和强权政治在国际政治、经济和安全领域中的现实存在，正在威胁乃至危害世界和平与国际安全。中国的和平崛起，面对的是惯于目空一切、信奉“炮舰政策”和经济殖民的西方强权的阻挠；中国提出的“建立人类命运共同体”以及“一带一路”等倡议正遭受来自西方国家的正面挑战和全面围堵；全球贫富差距的不断增大、干涉他国内政事件的频发、国际恐怖主义的泛滥，等等，都不利于我们在优化国际环境、维护国家安全、领土完整和巩固现有制度方面所做出的不懈努力。外交之重要已不言而喻，而针对外交政策的研究则更是刻不容缓。`,
      texttwo: `作为方向性选择我们在观察和分析国际关系现状以及各国外交政策的同时，有意识地弱化外交理论方面的研究与创新，而更强调研究工作的现实性和实用性，从决策的视角分析外交政策形成的机制和决策者思维，深入了解各国决策者与本国利益集团之间的关系，客观分析国与国之间相互依存的现状与成因，全方位地剖析国家集群和结盟国家的利益诉求及内在矛盾的根源与发展趋势，并进而对国际关系大局以及各国外交政策作出预判。与此同时，在积极倡导以和平与发展为宗旨的新时期国际关系与秩序的同时，我们也不断研究和探索在外交领域争取主动的策略与方法。`,
    }
  }, {
    title: '国防安全',
    info: {
      picture: gImg.ResearchDirection.four,
      textone: `我国地处印太海洋地缘战略和亚欧大陆地缘战略区的交汇处，是陆上势力和海上势力争夺的焦点，这已决定了我国的强大与美国的全球战略必然相悖，而俄国作为横跨欧亚的大国，其重新崛起的雄心是否将危及我国的安全也将值得关注。同时，冷战结束以来，部分周边国家也已调整了军事战略，加强了军事装备的研发与发展，从整体上改变了我国周边的军事环境。由于历史遗留问题，我国与一些周边邻国之间还存在着某些悬而未决的边界领土之争和海权纠纷。此外，国内外分裂势力在新疆、西藏、香港和台湾的活动从未停止。认清形势及其事务的本质，乃是我们从事国防安全研究的前提。`,
      texttwo: `与此同时，我国对全球经济发展的贡献近年来已高达30%左右，可谓是全球经济发展中一股强劲的动力，中国企业的投资因此也自然已延伸至了世界各地。我们虽信奉和平崛起、永不称霸的原则，但如何保障我们的合法权益和正当利益不受侵犯、不被肆意践踏，也是国防安全范畴内的一大课题。在经济全球化的当下，如何正确并有效地保护中国企业在海外的投资，捍卫国家与国民的尊严，也理应被视为是国防安全的一部分，也是摆在我们面前的一项重大课题。我们在国防安全领域的研究因此也延伸至捍卫中国在海外的资产和投资的策略与手段。`,
    }
  }, {
    title: '战略定位',
    info: {
      picture: gImg.ResearchDirection.five,
      textone: `国家的战略定位既反映出国家发展的目标和愿景，也是国家在谋求自身发展和处理国际关系进程中的基石，是面对当下事务做出各种判断和决策的准绳。与此同时，战略定位并不是一个独立和封闭的课题。在谋求和平与发展的道路上，针对我国战略定位的研究，所涉及的层面十分广阔，包括对不断变化的国际政治、军事和经济环境的客观研判，对他国战略的了解和认知，以及对自身实力和潜力的诚实和精准评估。据此，我们也应该看到，国家的战略定位也不是一成不变的，也不断受制于自身和外部因素乃至特发事件的变化和影响，故动态性和时效性也是战略定位研究的另一大特征。`,
      texttwo: `二战结束后的大半个世纪以来，尤其是自冷战结束后，国际间在政治、经济和军事三大层面已发生了翻天覆地的变化，以西方发达国家尤其是以美国为主导的原有国际格局正在向一个多极世界演进，中国在经济领域不仅取得了惊人的成就，在军事和国防领域也有了长足的发展，国际地位与日俱增。在貌似无序和混乱的当下，如何不被眼前的迷雾所误导，如何认清形势、辨别是非，如何不畏强权、据理力争，从而坚定不移地走出中国自己的发展道路，如何让更多国家和人民从了解和理解中国到信任和支持中国，当务之急是我们从事战略定位研究的现实意义所在。
`,
    }
  }, {
    title: '国别研究',
    info: {
      picture: gImg.ResearchDirection.six,
      textone: `国别研究是国际关系和国际政治研究领域的重要环节之一，也是基础。研判一个国家的现状，我们不仅需要对其历史、人文和经济发展有深入的了解，而且还必须对其社会制度和政治生态有较为全面的认知，包括对其政治体制，尤其是主要政党及其所控制或受控的利益集团的背景以及相互间的依存关系，乃至该国在所属的区域和国际组织中的主导或从属地位，等等。在经济全球化之当下，尤其是当我们正处在从经济大国走向经济强国的过程中，大量中国企业正在积极参与各国的基础设施建设与投资，正在扩大双向和多边贸易的进程中，国别研究的重要性更显突出。`,
      texttwo: `我们崇尚且也得益于全球知识和信息共享。我们的数据采集和信息来自于亚洲、欧洲、美洲和非洲超过170个国家的政府统计部门以及当下各主要国际和区域组织乃至多个全球主流咨询机构所公开发布的信息渠道。与此同时，凭借我们自身研究人员与遍布世界各地合作机构保持长期紧密沟通这一独特的资源平台，我们有能力做到随时掌握全球各主要国家的市场信息，并做到及时更新。我们与环球华置投资机构联合推出的独具特色的中英文对照系列出版物《国家概况》，按照统一的编撰、译审与设计规程制作并出版，配有相应国家的驻华使领馆乃至国家领导人的亲笔背书，业已成为炙手可热的资讯读物。`,
    }
  }, {
    title: '政治风险',
    info: {
      picture: gImg.ResearchDirection.seven,
      textone: `政治风险评估是针对目标国或区域的政治环境的专题性研究，其重心是研究政治决策、政治事件和政治环境可能对特定经济活动的预期收益所产生的影响，对政治风险的正确研判同样也将影响政府在推行外交、军事或其他政策的能力。从广义上来看，我们应该对人类社会发展的规律、对政治学说和理论的演进、对国际格局的现状与发展趋势等要有客观和基本的认识与判别；而回归到现实政治，我们则必须从各国的实际国情入手，深入了解和研究其政治生态及其自身在国际关系中的定位以及所秉持的原则，进而对其政权的稳定性及其政策的持续性做出客观理性的预测。`,
      texttwo: `在企业的跨境投资和海外扩展过程中，针对目标国进行相关政治风险分析和评估的重要性尤为凸显。当项目所在地是另一国度，且企业自身对该国度的情况又缺乏深入了解，或仅仅依赖某些熟人和商业关系的引荐便贸然行事，其风险程度不言而喻。绝大多数中国企业因长期习惯于中国境内的营商环境，加上语言文化的障碍，对外部世界知之甚少，对如何规避政治风险更是不得要领。本中心的政治风险评估部门人才济济，并由资深的专业研究人员执掌，不仅擅长对欧美发达国家的政治体制和决策机制了如指掌，近年来更对中东欧和非洲等发展中国家的政治生态展开了深入的研究。`,
    }
  }, {
    title: '跨国贸易',
    info: {
      picture: gImg.ResearchDirection.eight,
      textone: `作为当今世界最大、综合实力最强的发展中国家，我国在国际间的地位不仅已提升至史无前例的高度，而且随着时间的推移，在可预见的未来，我国必将成为全球最大的经济体，这已是不争的事实。由此可见，拥有近15亿人口的中国，在行将成为全球最大的贸易国的途中，在国际间所将遭遇的对手乃至抵抗可想而知，如何维系和不断增进与各国间的经贸往来、缓解摩擦和避免大规模贸易冲突，如何做到未雨绸缪，努力创造有利的国际环境，有效预见和采取积极的防范措施等，将决定我国未来几十年乃至上百年发展成败之关键，也是所有关心国家命运的有识之士所不该忽略的重要课题。`,
      texttwo: `我们在此领域的研究方向侧重于对新兴市场及其潜力的纵向调研和案例分析，包括中东欧地区、中亚诸国、俄罗斯、非洲等地区的现状以及与中国在发展经贸和投资往来的道路上所面临的困境或瓶颈，中国企业在前往该等地区和国家寻求商机和发展过程中应如何规避风险，如何将企业的海外拓展事务与国家的宏观经济发展规划有效的结合，等等。与此同时，我们也积极倡导与企业进行形式多样的互动，与之分享我们的心得及研究成果，鼓励企业决策层对国际事务的关心，在管理意识、人才选拔和培训等方面为企业献计献策，协助提升中国企业的整体国际化水准。`,
    }
  }],
  huantai: {
    one: '环太学术研讨',
    onecopy: '环太学术研讨copy',
    two: '环太海外论坛',
    twocopy: '环太海外论坛copy',
    three: '环太学者风采',
    threecopy: '环太学者风采copy',
    four: '环太专业文刊',
    fourcopy: '环太专业文刊copy'
  },
  language: '语言',
  nationality: '国籍',
  position: '职位',
  Email: '邮箱',
  //
  rule: {
    content: '<p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><strong><span style=";font-family:微软雅黑;font-size:27px">惜才纳贤</span></strong></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><strong><span style=";font-family:微软雅黑;font-size:17px">&nbsp;</span></strong></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><strong><span style=";font-family:微软雅黑;font-size:17px">实习生计划</span></strong></p><p style="margin-bottom:0"><span style=";font-family:宋体;font-size:13px">&nbsp;</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">本中心为本科生和研究生提供实习机会，理想的应聘者需安排出不短于</span>3个月的实习期和每周40小时的工作时间，理想的专业背景包括国际政治、国际关系、国防外交、社会公共事务管理、法学、政治、历史，或英语语言及文学。一经录用，您将会被安排在本中心实习。实习期间，您将学到如何从事专题研究和分析、如何从事国别研究、如何撰写研究报告、如何策划与组织专题论坛、如何撰写新闻稿、如何解读时政要闻、如何进行国际间交流， 等等，有机会跟随资深研究人员和知名业界专家参与课题研究，并接受来自不同文化背景的专业人士的相关指导。完成实习的学生将会获得本中心出具的推荐信，优秀的实习生可能会在实习期间或之后被本中心正式聘用。</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:13px"><br/></span><span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">申请人需将个人简历和近照等材料，邮寄至上海市天钥桥路</span>333号腾飞大厦10楼1001室，台启：环太国际战略研究中心秘书处；或发电邮至：recruits@rimpac-shanghai.cn。来函需注明“实习申请”的主题。本中心秘书处经初审通过后，会安排时间约见申请人，并定期将申请人情况汇总，报本中心“执行管委会”作最终审核。一旦评审通过，本中心将向入选申请人发放通知，与其签署《实习生约定书》。中国籍申请人优先。</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:13px">&nbsp;</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:13px">&nbsp;</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><strong><span style=";font-family:微软雅黑;font-size:17px">奖学金计划</span></strong></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:13px">&nbsp;</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:13px">本中心致力于人才储备和对年轻学者的培养，为有志于在国际政治、国际关系、国防外交、社会公共事务管理等领域继续深造的本科毕业生提供奖学金。年度奖学金名额共五人，本中心于每年第二季度公布当年奖学金总额以及与本中心签约接受本中心委培研究生的教育机构及其专业清单。</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:13px"><br/></span><span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">申请人需将个人简历、本科毕业成绩单以及申报研读和深造的专业方向等材料，邮寄至上海市天钥桥路</span>333号腾飞大厦10楼1001室，台启：环太国际战略研究中心秘书处；或发电邮至：info@rimpac-shanghai.cn。来函需注明“奖学金申请”的主题。本中心秘书处经初审通过后，会安排时间约见申请人，并定期将申请人情况汇总，报本中心学术委员会作最终审核。一旦评审通过，本中心将向成功获选的申请人发放通知，与其签署《奖学金发放约定书》。中国籍申请人优先。</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:13px">&nbsp;</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:13px">本中心根据个人专业背景等实际情况，欢迎奖学金获得者在学习和研读期间可申请参与本中心相关课题研究的工作，但无任何硬性指标和要求。作为本中心的委培研究生，本中心有权要求其在毕业后为本中心供职和工作不少于两年时间，具体事项参照《奖学金发放约定书》内容。</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:13px">&nbsp;</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:13px">&nbsp;</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><strong><span style=";font-family:微软雅黑;font-size:17px">助理研究员</span></strong></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style=";font-family:微软雅黑;font-size:17px">&nbsp;</span></p><p style="margin-bottom:0;text-align:justify;text-justify:inter-ideograph;background:rgb(255,255,255)"><span style="font-family: 微软雅黑;font-size: 15px">助理研究员负责查找、查验本中心数据库中需要定期更新的全球一百多个国家的各类数据、图库和信息。该岗位其他职责包括：按规定的格式与标准参与本中心相关课题研究以及研究报告和《国家概况》系列出版刊物的编写；参与此等工作的助理研究员的姓名将会被列入该等报告和出版刊物的研究或创作人员名单中。理想应聘者的专业背景以国际政治、国际关系、历史、经济学、哲学、法学，或英语语言及文学为佳。</span></p><p style="margin-bottom:0"><span style=";font-family:宋体;font-size:15px">&nbsp;</span></p><p style="margin-bottom:0"><span style=";font-family:宋体;font-size:15px">&nbsp;</span></p><p style="margin-bottom:0"><strong><span style=";font-family:微软雅黑;font-size:17px">时政研究员</span></strong></p><p style="margin-bottom:0"><span style=";font-family:宋体;font-size:15px">&nbsp;</span></p><p style="margin-bottom:0"><span style=";font-family:宋体;font-size:15px">&nbsp;</span></p><p style="margin-bottom:0"><span style=";font-family:宋体;font-size:15px">&nbsp;</span></p><p style="margin-bottom:0"><span style=";font-family:宋体;font-size:15px">&nbsp;</span></p><p style="margin-bottom:0"><strong><span style=";font-family:微软雅黑;font-size:17px">投资分析师</span></strong></p><p style="margin-bottom:0"><span style=";font-family:微软雅黑;font-size:15px;background:rgb(255,255,255)">&nbsp;</span></p><p style="margin-bottom:0"><span style=";font-family:微软雅黑;font-size:15px;background:rgb(255,255,255)"><span style="font-family:微软雅黑">投资分析师的主要职责是负责通过市场或行业研究为各类跨国投资项目的可行性研究（包括在发达国家和新兴市场的项目）提供支持。具体工作内容包括：参与项目背景资料的搜集、查证，分析行业现状及前景，了解市场准入及政策法规，审核项目或企业财务数据等相关信息，编制项目简介等。投资分析师将有机会逐步了解项目投资及融资结构所涉及的全部事项，并有机会与中外资深投资专家共事。理想应聘者的专业背景以经济学、法学、财会或银行与金融为佳。</span></span></p><p style="margin-bottom:0"><span style=";font-family:宋体;font-size:15px">&nbsp;</span></p><p style="margin-bottom:0"><span style=";font-family:宋体;font-size:15px">&nbsp;</span></p><p style="margin-bottom:0"><strong><span style=";font-family:微软雅黑;font-size:17px">政治风险评估师</span></strong></p><p style="margin-bottom:0"><span style=";font-family:宋体;font-size:15px">&nbsp;</span></p><p style="margin-bottom:0"><span style=";font-family:微软雅黑;font-size:15px;background:rgb(255,255,255)"><span style="font-family:微软雅黑">政治风险评估师负责参与有关企业跨境投资过程中的政治风险评估的专业研究工作，研究范围包括：相关国家的历史、文化、政治与经济现状及国家特色；政治生态与党派内情、选举制度、立法与司法程序、廉政举措等；外交政策以及所属国际组织对其的约束等。理想应聘者须对政治风险研究有浓厚兴趣，专业背景以政治学、国际关系学或历史学为佳。</span></span></p><p><br/></p>'
  },
  //bylaws.vue
  bylaws: {
    listone: [{
      id: 'b0',
      title: '中心简介',
      info: [{
        number: '01.',
        text: '上海环太国际战略研究中心成立于2000年8月，是在上海市民政局合法注册登记的民办非企业单位（法人），上海市社会科学界联合会为业务主管单位，作为在时任海峡两岸关系协会会长汪道涵的关心下最早成立的民间智库之一，本中心致力于围绕中国政治、经济发展和安全利益有关的课题与政策研究，以中国利益为先，以保障我国在全球范围内的经济利益、在国际事务中获取更大的话语权为己任，倡导建立以和平与发展为宗旨的新时期国际关系与秩序。',
      }, {
        number: '02.',
        text: '本中心在制定阶段性研究方向和课题过程中，不仅关注国际局势的风云变换，更注重正在逐渐走向国际舞台的中国的国际战略、国际关系、国际形象、国际话语的探索与论证。中心自成立以来，曾先后完成了一系列涉及全球战略、国家安全和两岸关系等重大课题研究，与国内外多个智库合作开展学术交流活动和举办国际学术研讨会，每年向政府提交专题报告和政策建议编译出版研究报告、论文专著和战略从刊，受到政府有关领导和学术界的高度重视，部分已被中央领导采纳并付诸实施。2006年和2021年，本中心先后获评“上海市优秀民办社科研究机构”称号。',
      }, {
        number: '03.',
        text: '随着我国综合国力的不断增强以及在国际间地位的提升，尤其是伴随大国博弈的日趋激烈本中心与时俱进，积极主动地参与乃至主持国际学术交流、并开拓研究领域在原有架构的基础上，增设多个区域研究中心陆续创建定期刊物和系列讲座为青年学者和研究专才提供奖学金计划、务求不辱使命，领行业之先，更好更全面地为政府和企业建言献策，并提供具国际水准的专业咨询服务。',
      }],
    },
    {
      id: 'b1',
      title: '环太使命',
      info: [

        {
          text: `本中心为非政府民间研究机构，致力于推进全球知识共享和公开性研讨，是以地区性和国际性战略要务以及重大国际关系议题为主要研究对象的学术研究机构，也是为此所建立的开放式交流平台。作为独立的民间智库，本中心的执行管理机构“执行管委会”严格尊照中心理事会的既定方针和指引，组织和协调中心的研究工作及相关活动，为地方和中央政府建言献策。同时，本中心也面向社会和企事业单位为服务对象，接受课题委约并提供专题研究报告。`,
        }, {
          text: `过去二十年间，本中心凭借始创团队的积极努力和辛勤耕耘，专注于针对中国国家安全和政治经济发展紧密相关的环太平洋国家和地区的研究，取得了丰硕的成果。随着国际地缘政治以及大国关系的不断变化和演进，中国在国际政治和经济等领域的影响力正在快速提升，但所面临的外部环境则日趋复杂和纷乱。二战后所建立的以美国为首的西方霸权主导的国际移序正在逐步瓦解，而新的国际秩序却尚未形成，新的国际安全问题正在不断涌现。为此，本中心也顺应时代的变化，将研究范围覆盖至全球。`,
        }, {
          text: `本中心坚持认为，人类的前行之路应以和平与发展为宗旨，以各国、各民族间的相互尊重为前提，反对任何国家将其自身的价值观和社会制度强加于他国之上的独断专横；我们尊崇和平外交、互为谦让，相互学习的国际关系，反对以大欺小、以强欺弱的野蛮行事；我们尊重各国的主权和领土完整以及对政治体制的选择，坚决反对侵占他国领土和干涉他国内政的粗暴行为。据此，我们将努力为中国更好地融入世界，为在全球范围内创建一个新的和谐时代做出贡献。 `,
        }]
    },
    {
      id: 'b2',
      title: '核心优势',
      info: [{
        number: '04.',
        text: '本中心是在上海市民政局合法注册登记的民办非企业单位，上海市社会科学界联合会为业务主管单位。中心人才济济，汇集了业内广受认可的中外专家学者，以国际时政、国际话语、外交政策、国防安全、战略定位、国别研究、政治风险和跨国经贸为既定的八大研究领域，见长于时政研究和对国际局势的洞察与研判，为企业的战略规划建言，并为政府的外交方略献策。',
      }, {
        number: '05.',
        text: '本中心聚集中外政治学、经济学、历史学、自然科学等领域的专家学者及政策研究人员。我们不仅潜心参与世界各国政治、经济和军事形势以及外交政策的研究工作，编写深度详实的分析报告，还接受政府机构和客户企业的委托，开展专项课题研究、社会调查以及国内外重大事件的专题分析，努力推动与政府部门和企业间的知识共享，为理性决策提供必要的理论基础和现实依据。',
      },],
    }],
    listtwo: [{
      id: 'b8',
      title: '管理规章',
      info: [{

        text: `本中心《管理规章》乃根据中心《章程》及理事会于2019年10月31日通过的特别决议及批准生效的《管理规章》之修设版，由中心“执行管委会”修订并于2021年12月30日重新审定后生效和开始执行。本中心执行管委会保留对本文件之解释权点击可下载<a class='red textDecoration' href='` + BASE_URL + `/uploads/guanliguizhang.pdf' download target='_blank'>《管理规章》</a>全文。`,

      }]
    }, {
      id: 'b9',
      title: '研究方法',
      info: [{

        text: `本中心提倡录活多样的研究方法。我们根据不同的研究课题和任务特性，同时也兼顾课题或任务所及的国家或地区的实际情况，以及相关社会、政治、经济形势的多样性、多变性和复杂性，情采用对比分析法、定性分析法、定量分析法等，进行深入仔细的研究，以求全面客观地反应事件或事物的现状和本质，从整体战略和宏观规划的角度出发，明确主体的长远和现实利益，有理有据地提出我们的看法、观点、推测、建议，等等。`
      },
      {
        text: `本中心汇集英才，我们日益壮大的研究团队来自中国和世界各地的学术精英和独立研究人才，具有跨地域、跨文化、跨专业、多语种的综合优势，在宏观战略、产业经济、时政观察、政治生态、外交政策、国防安全、政策咨询、施政管制、公共设施、社会调查、学术研究等领域均有深厚的专业背景和丰富的研判经验，确保能根据项目实情和客户需求有针对性地组建专案团队，满足课题及客户的需求。`,
      }]
    }, {

      id: 'b10',
      title: '联系我们',
      info: [{

        text: `若就本中心事务以及我们所提供的服务有任何查询，烦请与相关项目主管直接联系，也欢迎前来本中心接洽，电话：8621 6121 8787，地址：上海市徐汇区天钥桥路333号腾飞大厦10楼1001室。一般查询或提问，烦请发邮件至：www.info@rimpac-shanghai.cn`,

      }]
    }],
    listthree: [{
      tiblie: '职业操守：',
      text: '本中心始终坚持最高标准的职业道德规范，我们尊重知识产权，反对抄袭与非法使用信息，开展自主研究工作，坚持使用公开信息与数据并注明信息来源，竭力保护客户利益与隐私，致力于提供一流的服务。本中心承诺为客户及委约方提供专业、客观的研究分析结论及针对性建议，最大限度地维护客户及委约方的利益。'
    }, {
      tiblie: '服务提供：',
      text: '根据业务性质和提供服务的方式，本中心将根据不同的客户和委约项目按需选拔和组建具有相关资质和经验的专家组建专题“项目团队”。但所提供的一切研究和咨询服务始终由本中心冠名，并本中心在任何情况下都全部的合同义务。',
    }, {
      tiblie: '合同签署：',
      text: '本中心所进行的研究工作、提供的服务、与其他机构达成的合作及雇佣的员工均通过签订合同或约定书的形式来确立。本中心所有合同或约定书均由本中心“执行管委会”主任签署主任无法到场时，则由“执行管委会”其他委员代签。',
    }, {
      tiblie: '标准约定：',
      text: '本中心针对所提供的研究或咨询服务时要求客户或委约方接受并认可本中心的《标准约定》，该《标准约定》必须作为本中心与客户或委约方签署的协议之不可分割的附件存在。《标准约定》内不适用的个别条款，可通过所签署的具体服务或委约协议加以修订。',
    }, {
      tiblie: '委员任命：',
      text: '本中心“顾问委员会”和“学术委员会”的委员均由“执行管委会”负责任命，任命函需由本中心理事长和秘书长联合签署方可生效。',
    }, {
      tiblie: '聘用规范：',
      text: '本中心根据所在地现行的劳动法规自行定制适用于本中心的标准《员工聘用合同》，所有受聘于本中心的员工均需签署该《员工聘用合同》。“执行管委会”有责任确保每位受聘员工在签署《员工聘用合同》时都已知晓并同意相关协议内的内容和相互约定。',
    }, {
      tiblie: '版权界定：',
      text: '本中心在正常运营过程中会不时地通过公开渠道发布本中心的消息以及由本中心组织编写的报告和撰文以及刊物。除非另有专题说明，所有该等报告和撰文以及刊物的版权一律归本中心所有，任何人不得在未事先征得本中心同意的情况下引用或使用这些报告和撰文以及刊物中的部分或全部内容。',
    }, {
      tiblie: '隐私政策：',
      text: '本中心承诺保护所有客户及合作伙伴的个人隐私及其私人信息，坚守最高标准的保密规范，在收集、使用客户个人信息和企业信息以及依法提供该等信息过程中，将始终遵守中国或其他相关司法管辖区的《个人信息保护法》及其他适用法律。本中心的隐私政策在官网上公布，但随时有权对其部分或全部内容进行修改、修订、修正或废除，无需事先向任何个人或单位征得其同意或许可。',
    }, {
      tiblie: '公共形象：',
      text: '为不断提升本中心的公共形象，增强本中心的辨识度和知名度，所有中心人员的名片、信笺抬头、官网、微信公众号、报告及刊物封面、宣传资料上均载有本中心注册标识与专用图像。',
    }, {
      tiblie: '利益冲突：',
      text: '本中心在为客户及委约方提供服务过程中，将尽可能采取必要的措施来预估和防范可能出现的利益冲突，但由于利益冲突的判别标准各不相同等原因，本中心无法保证能事先判断出所有已存在或将来可能出现的利益冲突。因此，本中心“执行管委会”以及所有负责项目接洽的本中心员工将尽可能提前与客户和委约方就避免发生利益冲突等事宜进行充分的沟通。',
    }, {
      tiblie: '纠纷解决：',
      text: '本中心在接受委约从事研究工作和其他活动中遇到纠纷时，一般会先尝试采取与另一方协商或调解等方法来解决矛盾，不得已才会诉诸法律。本中心所签订的每份合同中都必须约定司法管辖区以及适用法律，且约定所有与合同相关或在执行合同过程中所引起的任何纠纷均应由合同中约定的仲裁机构进行仲裁，仲裁程序应符合当时的现行规则。仲裁庭应由根据仲裁机构的现行规则选出不少于三名仲裁员组成。仲裁机构的裁决为最终裁决，对争议各方均具有约束力。'
    }],
    listfour: [{
      tiblie: '资金来源与财务管理：',
      info: [{
        number: '49.',
        tiblie: '主要资金来源',
        text: '本中心作为研究机构和民间智库，并非以盈利为目的，资金来源面向社会筹集，并通过自身运营获取合理、合法的收入，以支撑和维系中心的日常运营所需。本中心的收入来源主要分为：接受机构理事单位的捐赠资助、团体会员年费、个人会员年费、学生会员年费受托研究经费以及咨询服务收入。'
      }, {
        number: '50.',
        tiblie: '机构理事单位',
        text: '本中心理事会深知，中心的发展和壮大离不开对资金的需求。新一届理事会经改组后，决定由中心副理事长王南森先生所拥有的“环球华置商务服务（上海）有限公司”免费为本中心提供注册地址和办公场所，并提供中心运营所需的各项费用和支出。然而，作为民间智库，若本中心仅仅依赖某一家企业的资助，不仅可能受制于出资方的经营状况，因此风险较大，更重要的是，长此下去，中小容易蜕变成该企业的附属机构，将失去研究机构和智库应有的独立性。为此，新一届理事会经过慎重考虑后，决定在2020年6月31日前，在中国的金融、建筑、资产管理、综合性投资跨境贸易等行业内选择有意向或已经在全球范围内拓展其业务的机构，且该等机构亦认同本中心的宗旨和使命的，欢迎该等机构以出资和捐赠等方式成为本中心的“机构理事单位”，具体出资与捐赠金额由本中心“执行管委会”与有意向的企业或机构洽商并签约。“执行管委会”将适时颁布或修改《机构理事单位招募指引》，“机构理事单位”有权提议并资助课题研究或公益性计划的实施，有义务参与审阅本中心年度报告和计划、年度财务报告，但不得干涉本中心的日常运营和管理等任何日常事务。'
      }, {
        number: '51.',
        tiblie: '主要资金来源',
        text: '本中心严格按照所在地的财税政策和相关法律法规如实记录中心日常运营所发生的所有收支，以严格的内部财务管理制度和规范自我约束、合规守法，向社会和税务部门公开本中心的所有资金和收人来源，并接受主管部面的监督。'
      }],
    }],
    listfive: [{
      tiblie: '规章修订',
      info: [{
        number: '52.',
        text: '本中心“执行管委会”可根据中心的实际运营状况以及发展需求，向理事会就本《管理规章》提出修订或修正建议。针对本《管理规章》的任何修订或修正必须经理事会投票批准，赞同票数须不少于三分之二方可视为通过并生效。',
      }, {
        number: '53',
        text: '修订或修正内容经理事会批准生效后，“执行管委会”需及时将相关内容以公函形式告知本中心顾问委员会、学术委员会、机构理事单位、合作伙伴机构、团体会员、个人会士、学生会员以及全体员工，并在本中心的官网和其他公众平台上对《管理规章》作出及时更新。'
      }]
    }],
    contactInformation: {
      one: '【 2021年12月21月31日更新 】',
      two: '上海环太国际战略研究中心',
      three: '中国上海市天钥桥路333号腾飞大厦10楼1001室  /  邮编：200030',
      four: '电话： 86 21 61218787',
      five: '电邮： info@rimpac-shanghai.cn',
    },
    textList: {
      one: '确立本中心的宗旨、使命及核心价值；',
      two: '确立本中心的发展战略，确保实现战略目标；',
      three: '制定本中心顾问委员会、外国专家咨询委员会、学术委员会、奖学金评议委员会的成员挑选标准和管理规范，对各委员会的运行和管理负责；',
      four: '负责研究课题、委约项目、出版物、论坛、会议、培训计划的选题和实施，并根据本中心发展和项目需要，责任选拔和招聘人员；',
      five: '负责向中央政府、地方政府、区域性组织、国际组织、公共机构以及企业客户提供有偿顾问和咨询服务的具体实施与管理；',
      six: '为本中心制定稳健的财政预算和公开透明的财务制度，确保所有合作研究项目以及各类活动的预决算做到向合作单位及个人完全公开；',
      seven: '根据本中心发展和实际需要，就本中心战略目标等重大方向性选择项理事会提交建议；',
      enght: '负责本中心官网、微信公众号等对外平台的设计、运行和日常管理，以及对外新闻稿的撰写和消息发布；',
      nine: '本着面向社会、服务社会的宗旨，负责创建“环太机构理事会员”、“环太个人会员”和“环太学生会员”，收取会费并为会员提供相应的服务；',
      ten: '向理事会提交年度总结报告，执行并完成理事会赋予的职责。',
      eleven: '确立本中心的宗旨、使命及核心价值；',
    }
  },
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js